import * as React from "react";

const Ncs: React.SFC<{}> = () => {
    return (
        <div>
            NCS!
        </div>
    );
}

export default Ncs;